import { FormTextField, FormPasswordField } from '../molecules/form-elements';
import { Stack, Link, Typography, Box } from '@mui/material';
import { StyleObj } from '../../@types';
import useAuthForms from '../../hooks/useAuthForms';
import StyledForm from '../forms/shared/StyledForm';
import { useLoginForm } from '../../hooks/useLoginForm';

const styles: StyleObj = {
  loginContainer: {
    mt: 4,
    mb: 2,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 1,
  },
  forgotPasswordWrapper: {
    textAlign: 'right',
  },
  forgotPassword: {
    cursor: 'pointer',
    color: 'neutral.50',
    typography: 'body2',
    '&:hover': {
      color: 'primary.500',
    },
  },
};

const LoginForm = () => {
  const { openRegisterForm, openForgotPasswordForm } = useAuthForms();
  const { t, control, errors, isSubmitting, handleClose, onSubmit } = useLoginForm();

  return (
    <>
      <StyledForm
        title={t('register.signIn')}
        submitTitle={t('register.signIn')}
        onSubmit={onSubmit}
        onClose={handleClose}
        isSubmitting={isSubmitting}
      >
        <FormTextField
          name='email'
          control={control}
          label={t('register.email')}
          variant='outlined'
          fullWidth
          type='text'
          error={!!errors.email}
          helperText={errors.email?.message}
          disabled={isSubmitting}
        />
        <FormPasswordField
          name='password'
          control={control}
          label={t('register.password')}
          error={!!errors.password}
          helperText={errors.password?.message}
          disabled={isSubmitting}
          slotProps={{ htmlInput: { autoComplete: 'new-password' } }}
        />
        <Box sx={styles.forgotPasswordWrapper}>
          <Link component='button' type='button' onClick={openForgotPasswordForm} sx={styles.forgotPassword}>
            {t('forgotPassword.title')}?
          </Link>
        </Box>
      </StyledForm>
      <Stack sx={styles.loginContainer}>
        <Typography variant='body2'>{t('register.noAccountYet')}</Typography>
        <Link component='button' onClick={() => openRegisterForm()}>
          {t('register.title')}
        </Link>
      </Stack>
    </>
  );
};

export default LoginForm;
